import { connect } from 'react-redux';
import Map from './Map.jsx';
import { selectGravestone, changeCenterAndZoom, changeBounds } from '../store/actions';
import { getGravestonesParsed, getPerimeter, showInset } from '../store/selectors';

const mapStateToProps = (state) => {
  const { zoom, center, bounds, selectedGravestone, userLocation } = state;
  return {
    gravestones: getGravestonesParsed(state),
    selectedGravestone,
    zoom,
    center,
    bounds,
    perimeter: getPerimeter(),
    userLocation,
    showInset: showInset(state),
    hillshadeOn: state.hillshadeOn,
  };
};

const mapDispatchToProps = dispatch => ({
  selectGravestone,
  changeCenterAndZoom,
  changeBounds,
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);



// WEBPACK FOOTER //
// ./src/components/Map.js